import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import SystemControls from './systemControls';
import StreamStatsTab from './streamStatsTabs';
import SystemStatsTab from './systemStats';
import StreamQosStats from './streamQosStats';
import WebrtcSender from './webrtcSender';
import PictureApiTest from './pictureApiTest';
import AutoTest from './autoTest';
import VstLogs from './vstLogs';
import RecordEvent from './recordEvent';
import AddRtspUrls from './addRtspUrls';
import RagnarokPlayer from '../ragnarok-player/ragnarokPlayer.tsx';
import ChatBot from '../chatbot/chatbot';


function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" hidden={value !== index}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DebugTabs() {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const isStreamer = location.pathname === '/streamer/debug';
  const showDebugTag = useSelector((state) => state.app.showDebugOptions);
  useEffect(() => {
    setTimeout(() => {
      setValue(0);
    }, 200);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
          <Tab label="Tokkio Experience" {...a11yProps(0)} />
          <Tab label="System controls" {...a11yProps(1)} />
          <Tab label="Stream stats" {...a11yProps(2)} />
          <Tab label="RTSP stream QOS" {...a11yProps(3)} />
          <Tab label="System stats" {...a11yProps(4)} />
          <Tab label="Add streams from Nvstreamer" {...a11yProps(5)} />
          <Tab label="Chat Bot" {...a11yProps(6)} />
          {showDebugTag && <Tab label="Capture Picture Test" {...a11yProps(7)} />}
          {showDebugTag && <Tab label="Auto Test" {...a11yProps(8)} />}
          {showDebugTag && <Tab label="Logs" {...a11yProps(9)} />}
          {showDebugTag && !isStreamer && <Tab label="Event Recording" {...a11yProps(10)} />}
          {showDebugTag && !isStreamer && <Tab label="Ragnarok Player" {...a11yProps(11)} />}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <WebrtcSender />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SystemControls />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <StreamStatsTab />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <StreamQosStats />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <SystemStatsTab />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <AddRtspUrls />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <ChatBot />
      </TabPanel>
      {showDebugTag && (
        <TabPanel value={value} index={7}>
          <PictureApiTest />
        </TabPanel>
      )}
      {showDebugTag && (
        <TabPanel value={value} index={8}>
          <AutoTest />
        </TabPanel>
      )}
      {showDebugTag && (
        <TabPanel value={value} index={9}>
          <VstLogs />
        </TabPanel>
      )}
      {showDebugTag && !isStreamer && (
        <TabPanel value={value} index={10}>
          <RecordEvent />
        </TabPanel>
      )}
      {showDebugTag && !isStreamer && (
        <TabPanel value={value} index={11}>
          <RagnarokPlayer />
        </TabPanel>
      )}
    </Box>
  );
}
